import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styles from './Avatar.module.css';
/**
 * Derive up to two initials from a display name (pure, unit-tested).
 * "Sarah Mitchell" → "SM", "Cher" → "CH". Never returns a full name and never
 * guesses beyond the first letters of the first + last word.
 */
export function initials(name) {
    const words = name
        .trim()
        .split(/\s+/)
        .filter((w) => w.length > 0);
    if (words.length === 0)
        return '?';
    const first = words[0] ?? '';
    if (words.length === 1)
        return first.slice(0, 2).toUpperCase();
    const last = words[words.length - 1] ?? '';
    return (first.charAt(0) + last.charAt(0)).toUpperCase();
}
/**
 * Initials avatar (doc 04 §1), optionally showing a profile photo. Decorative —
 * the user's name is always also in text next to it, so neither the initials
 * nor the photo is ever the sole identity signal for AT.
 *
 * No client-side cropping: the server stores the image as uploaded (within
 * caps) and `object-fit: cover` center-crops at render time.
 */
export function Avatar({ name, size = 30, tone = 'water', src }) {
    const [broken, setBroken] = useState(false);
    // A new src is a new claim; forget that the previous one failed.
    useEffect(() => setBroken(false), [src]);
    const cls = tone === 'navy' ? `${styles.avatar} ${styles.navy}` : styles.avatar;
    const showPhoto = typeof src === 'string' && src.length > 0 && !broken;
    return (_jsx("span", { className: cls, style: { width: size, height: size, fontSize: Math.round(size * 0.38) }, "aria-hidden": "true", children: showPhoto ? (_jsx("img", { src: src, alt: "", className: styles.photo, onError: () => setBroken(true) })) : (initials(name)) }));
}
//# sourceMappingURL=Avatar.js.map